module.exports = __webpack_public_path__ + "static/media/E.81daaa5a.png";